<mat-expansion-panel class="integration-custom-field-settings" style="margin-bottom: 20px" *ngIf="sectionGroup">
  <mat-expansion-panel-header>
    <div fxLayout="row" fxLayoutAlign="start center">
      <ng-container *ngIf="integration.settings && integration.syncProvider === hhaSyncProvider">
        <mat-checkbox
          *ngIf="isHhaSection(sectionGroup, 'Sync HHAeXchange Caregivers')"
          [(ngModel)]="integration.settings.syncHhaCaregivers"
          (click)="$event.stopPropagation()"
        ></mat-checkbox>
        <mat-checkbox
          *ngIf="isHhaSection(sectionGroup, 'Sync HHAeXchange Patients')"
          [(ngModel)]="integration.settings.syncHhaPatients"
          (click)="$event.stopPropagation()"
        ></mat-checkbox>
      </ng-container>
      {{ sectionGroup.get('title').value }}
    </div>
  </mat-expansion-panel-header>

  <ng-container
    *ngIf="
      canEditTags && integration.settings.syncHhaPatients && isHhaSection(sectionGroup, 'Sync HHAeXchange Patients')
    "
  >
    <div class="integration-custom-field-settings__custom-label" fxLayout="row" fxLayoutAlign="start center">
      <span>Tags</span>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <app-mat-tags-multiselect
        fxFlex
        [(ngModel)]="integration.settings.hhaPatientsTags"
        name="tags"
        placeholder="Search Tags"
        [autoCompleteValues]="allTags"
        [suffixIcon]="canEditTags ? 'edit' : undefined"
        suffixTooltip="Manage Tags"
        (onSuffixClicked)="onManageTagsClick($event)"
        [submitted]="submitted"
      ></app-mat-tags-multiselect>
    </div>
  </ng-container>

  <ng-container
    *ngIf="
      canEditTags && integration.settings.syncHhaCaregivers && isHhaSection(sectionGroup, 'Sync HHAeXchange Caregivers')
    "
  >
    <div class="integration-custom-field-settings__custom-label" fxLayout="row" fxLayoutAlign="start center">
      <span>Tags</span>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <app-mat-tags-multiselect
        fxFlex
        [(ngModel)]="integration.settings.hhaCaregiversTags"
        name="tags"
        placeholder="Search Tags"
        [autoCompleteValues]="allTags"
        [suffixIcon]="canEditTags ? 'edit' : undefined"
        suffixTooltip="Manage Tags"
        (onSuffixClicked)="onManageTagsClick($event)"
        [submitted]="submitted"
      ></app-mat-tags-multiselect>
    </div>
  </ng-container>

  <ng-template matExpansionPanelContent>
    <div
      *ngIf="isHhaSection(sectionGroup, 'Sync HHAeXchange Caregivers')"
      class="integration-custom-field-settings__custom-label"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <span>Caregiver Custom Fields</span>
    </div>

    <div
      *ngIf="isHhaSection(sectionGroup, 'Sync HHAeXchange Patients')"
      class="integration-custom-field-settings__custom-label"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <span>Patient Custom Fields</span>
    </div>

    <app-mat-text-input placeholder="Search..." [formControl]="searchControl"></app-mat-text-input>

    <table mat-table [dataSource]="paginatedFields" [id]="sectionGroup.get('title').value" [trackBy]="trackBy">
      <ng-container *ngFor="let column of tableColumns" [matColumnDef]="column.key">
        <th mat-header-cell *matHeaderCellDef>{{ column.label }}</th>
        <td mat-cell *matCellDef="let field" [formGroup]="field">
          <ng-container *ngIf="column.key === 'fieldTitle'">
            {{ field.get('fieldTitle').value }}
          </ng-container>
          <ng-container *ngIf="column.key !== 'fieldTitle'">
            <mat-checkbox
              [id]="'checkbox' + column.key"
              [formControlName]="column.key"
              (change)="onCheckboxCheck($event, column.key, field)"
            ></mat-checkbox>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumnKeys; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumnKeys"></tr>
    </table>

    <mat-paginator
      #paginator
      [length]="filteredSectionFieldGroups.length"
      [pageSize]="5"
      [pageSizeOptions]="[5, 10, 25]"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  </ng-template>
</mat-expansion-panel>
